import { Modal } from "../../secondary/Modal";
import style from "./riskAssessmentScale.module.scss";
import { RiskScale } from "./RiskScale";

export const RiskAssessmentScale = ({ modalClose, scaleType, score }) => {
  return (
    <>
      {/* Modal */}
      <Modal
        modalOpen={true}
        modalClose={modalClose}
        heading={"Risk Assessment"}
        subHeading={(scaleType === "norton" ? "Norton" : "Braden") + ` Score:`}
        subNumber={score}
        className={style.assessment_modal}
        modalSize={style.custom_modal_size}
      >
        <RiskScale scaleType={scaleType} score={score} />
      </Modal>
    </>
  );
};
